export default "__VITE_ASSET__DheHw76L__"